/**
 * The geometry of a point marker, in px: a ring with a cross inside it and
 * a label beside it, so every point-like annotation reads alike.
 */
export const POINT_MARKER_RADIUS_PX = 6;
export const POINT_MARKER_CROSS_ARM_PX = 3;
export const POINT_MARKER_STROKE_WIDTH_PX = 1.5;
/** The label starts this far right of the centre, beside the ring. */
export const POINT_MARKER_LABEL_OFFSET_X_PX = POINT_MARKER_RADIUS_PX + 4;
/** The label's baseline sits this far below the centre, level with it. */
export const POINT_MARKER_LABEL_OFFSET_Y_PX = 4;
export const POINT_MARKER_LABEL_FONT_SIZE_PX = 14;
/** The ring's fill alpha on the displayed plane, and away from it. */
export const POINT_MARKER_FILL_ALPHA_ON_PLANE = 0.3;
export const POINT_MARKER_FILL_ALPHA_OFF_PLANE = 0.1;
/** The ring's dash on another slice. */
export const POINT_MARKER_OFF_SLICE_DASH = '2 2';
